import gql from 'graphql-tag';

export const fields = `
    accountId
    title
    createdAt
    updatedAt
`;

export const relationsFields = `
`;

// default methods
export const paginationQuery = gql`
    query ChatPaginateConversations (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        pagination: chatPaginateConversations (
            query: $query
            constraint: $constraint
        ) {
            total
            rows
            count
        }
    }
`;

export const getQuery = gql`
    query ChatGetConversations (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        objects: chatGetConversations (
            query: $query
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const findByIdQuery = gql`
    query ChatFindConversationById (
        $id: ID
        $constraint: QueryStatement
    ) {
        object: chatFindConversationById (
            id: $id
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const findQuery = gql`
    query ChatFindConversation (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        object: chatFindConversation (
            query: $query
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const createMutation = gql`
    mutation ChatCreateConversation (
        $payload: ChatCreateConversationInput!
    ) {
        chatCreateConversation (
            payload: $payload
        ) {
            ${fields}
        }
    }
`;

export const insertMutation = gql`
    mutation ChatCreateConversations (
        $payload: [ChatCreateConversationInput]!
    ) {
        chatCreateConversations (
            payload: $payload
        )
    }
`;

export const updateByIdMutation = gql`
    mutation ChatUpdateConversationById (
        $payload: ChatUpdateConversationByIdInput!
        $constraint: QueryStatement
    ) {
        chatUpdateConversationById (
            payload: $payload
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const updateMutation = gql`
    mutation ChatUpdateConversations (
        $payload: ChatUpdateConversationsInput!
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        chatUpdateConversations (
            payload: $payload
            query: $query
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const deleteByIdMutation = gql`
    mutation ChatDeleteConversationById (
        $id: ID!
        $constraint: QueryStatement
    ) {
        chatDeleteConversationById (
            id: $id
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const deleteMutation = gql`
    mutation ChatDeleteConversations (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        chatDeleteConversations (
            query: $query
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

// Mutation additionalApis
export const sendMessageMessageMutation = gql`
    mutation ChatSendMessageMessage (
        $payload: ChatUpdateConversationByIdInput!
        $constraint: QueryStatement
    ) {
        chatSendMessageMessage (
            payload: $payload
            constraint: $constraint
        )
    }
`;
